import * as entity from '@common/domain/entities/WorkOrder'
import { FormBuilderControlListHelper } from "../../formbuilder/FormBuilderControlListHelper";
import * as app from '@framework/app';
import { ViewType, FieldType } from "../../../framework/core/Enums";
import { IColumnOptions, IGridOptions, IEntityEndPoints, IDataEndPoint, IFormOptions } from "../../../framework/interfaces/IEntity";
import * as WorkOrder from '@common/domain/models/WorkOrderDTO';
import { IPropertyFilter } from "../../formbuilder/PropertyFilter";
import { FormBuilderControl, IFormBuilderControl } from "../../formbuilder/FormBuilderControl";
import { FormBuilderControlType } from "../../formbuilder/FormBuilderControlType";
import { IEntityModel } from "../../../framework/interfaces/IEntityModel";
import * as jobcard from '@common/domain/models/JobCardDTO';
export class WorkOrderEndPoints extends entity.WorkOrderEndPoints {
  search?: IDataEndPoint = { url: app.config.controllerRouteRoot + "/workOrder/search/", method: "POST" };
  pagingTotalCount?: IDataEndPoint = { url: app.config.controllerRouteRoot + "/workOrder/searchCount/", method: "POST" };}

export class WorkOrderFormFields extends entity.WorkOrderFormFields {
  constructor() {
    super();
	 try {
      if (this["id"]) this.splice(this.indexOf(this["id"]), 1)
      if (this["changedById"]) this.splice(this.indexOf(this["changedById"]), 1)
      if (this["datestamp"]) this.splice(this.indexOf(this["datestamp"]), 1)
    } catch  { }
    this.splice(this.indexOf(this.id), 1);
    this.splice(this.indexOf(this.datestamp), 1);
    this.splice(this.indexOf(this.status), 1);
    this.splice(this.indexOf(this.changedBy), 1);
    this.splice(this.indexOf(this.siteId), 1);
    this.splice(this.indexOf(this.jobNumberId), 1);
    this.areaId.name = "Area";
    this.areaId.viewType = ViewType.AutoComplete;
    this.areaId.searchEndPoint = { url: app.config.controllerRouteRoot + "/area/search/" };
    this.areaId.dataEndPoint = { url: app.config.controllerRouteRoot + "/area/" };
    this.areaId.dataDisplayField = "code";
    this.areaId.dataIdField = "id";
    this.contractManagerId.name = "Contract Manager"
    this.contractManagerId.viewType = ViewType.Dropdown;
    this.contractManagerId.dataEndPoint = { url: app.config.controllerRouteRoot + "/contractManager/" };
    this.contractManagerId.dataDisplayField = "email";
    this.contractManagerId.dataIdField = "id";


    this.priorityId.name = "Priority";
    this.priorityId.viewType = ViewType.Dropdown;
    this.priorityId.lookups = new Array();
    this.priorityId.lookups.push({ label: 'Emergency', value: 0 })
    this.priorityId.lookups.push({ label: 'Urgent', value: 1 })
    this.priorityId.lookups.push({ label: 'Planned', value: 2 })

    this.contactPersonId.name = "Contact Person";
    this.contactPersonId.viewType = ViewType.AutoComplete;
    this.contactPersonId.searchEndPoint = { url: app.config.controllerRouteRoot + "/contactPerson/search/" };
    this.contactPersonId.dataEndPoint = { url: app.config.controllerRouteRoot + "/contactPerson/" };
    this.contactPersonId.dataDisplayField = "name";
    this.contactPersonId.dataIdField = "id";
    }
}

export class WorkOrderForm extends entity.WorkOrderForm {
  protected workOrderFormEndPoints: WorkOrderEndPoints = new WorkOrderEndPoints();
  protected workOrderFormFields: WorkOrderFormFields = new WorkOrderFormFields();
}

export class WorkOrderListColumns extends entity.WorkOrderListColumns {
  constructor() {
    super();
	    try {
      if (this["id"]) this["id"].visible = false;
      if (this["changedById"]) this.splice(this.indexOf(this["changedById"]), 1)
      if (this["datestamp"]) this.splice(this.indexOf(this["datestamp"]), 1)
    } catch  { }
    this.splice(0, this.length);
    var idCol = FormBuilderControlListHelper.getListColumn("id", "id", ViewType.Text, "workOrder.id");
    idCol.visible = false;
    this.push(idCol);
    var jcprefix = FormBuilderControlListHelper.getListColumn("prefix", "prefix");
    jcprefix.visible = false;
    this.push(jcprefix);
    this.push(FormBuilderControlListHelper.getListColumn("wipStatus", "Wip Status", null, null, "formatted_wipStatus"));
    this.push(FormBuilderControlListHelper.getListColumn("workflowStatusId", "Workflow Status", null, null, "formatted_workflowStatus"));
    //this.push(FormBuilderControlListHelper.getListColumn("workflowStatusId", "Invoice Status", null, null, "formatted_workflowStatus"));
    this.push(FormBuilderControlListHelper.getListColumn("workOrderNo", "W/O No", ViewType.Text, "workOrder.workOrderNo"));
    this.push(FormBuilderControlListHelper.getListColumn("dateIssued", "Date Issued", null, null, "formatted_dateIssued"));
    this.push(FormBuilderControlListHelper.getListColumn("jobCardNo", "J/C No", null, null, "formatted_jobCardNo"));
    this.push(FormBuilderControlListHelper.getListColumn("priorityId", "Priority", null, null, "formatted_priority"));
    //this.push(FormBuilderControlListHelper.getListColumn("areaId", "Area", ViewType.Text, "workOrder.areaId"));
    //this.push(FormBuilderControlListHelper.getListColumn("operationId", "Operation"));
    //this.push(FormBuilderControlListHelper.getListColumn("functionalLocation", "Functional Location", ViewType.Text, "workOrder.functionalLocation"));
    //this.push(FormBuilderControlListHelper.getListColumn("functionalLocationDescription", "Functional Location Description", ViewType.Text, "workOrder.functionalLocationDescription"));
    this.push(FormBuilderControlListHelper.getListColumn("originalPurchaseOrderNo", "Orig. P/O No"));
    this.push(FormBuilderControlListHelper.getListColumn("plannedStartDate", "Plnd-Strt", null, null, "formatted_plannedStartDate"));
    this.push(FormBuilderControlListHelper.getListColumn("plannedCompletionDate", "Plnd-Cmp", null, null, "formatted_plannedCompletionDate"));
    //this.push(FormBuilderControlListHelper.getListColumn("disciplineDescription", "Discipline Description"));

  }
}
export class WorkOrderStaticFilters extends Array<IPropertyFilter> {
  constructor() {
    super();
    let control = new FormBuilderControl();
    control.controlType = new FormBuilderControlType(FieldType.String, null);
    control.displayName = "Work order no";
    control.bindingValue = "workOrder_workOrderNo";
    control.field = "workOrder_workOrderNo";
    control.show = function (scope) {
      return true;
    };
    this.push({ control: control, filterValue: '', whereFilterType: 1, columnName: "workOrder.workOrderNo" });

    let dateIssued = new FormBuilderControl();
    dateIssued.controlType = new FormBuilderControlType(FieldType.DateTime, null);
    dateIssued.displayName = "Date Issued";
    dateIssued.bindingValue = "dateIssued";
    dateIssued.field = "dateIssued";
    dateIssued.show = function (scope) {
      return true;
    };
    this.push({ control: dateIssued, filterValue: '', whereFilterType: 1, columnName: "dateIssued" });
  }
}

export class WorkOrderList extends entity.WorkOrderList {
  protected workOrderListEndPoints: WorkOrderEndPoints = new WorkOrderEndPoints();
  protected workOrderListColumns: WorkOrderListColumns = new WorkOrderListColumns();
  public get staticFilters(): Array<IPropertyFilter> { return new WorkOrderStaticFilters() };
  public relatedModels: Array<IEntityModel> = [new JobCardDTO(), new WorkOrder.WorkOrderDTO()]
}
export class JobCardDTO extends jobcard.JobCardDTO {
  public excludeModelPrefix: boolean = true;
}
